import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { getAllOffersApi, getOfferByIdApi, updateOfferStatusApi } from './offerApi';

// import { getAllEventApi, updateEventStatusApi, getEventByIdApi } from './eventApi';

// ----------------------------------------------------------------------

const initialState = {
  selectedOffer: {},
  isOfferLoading: false,
  offerList: []
};

const slice = createSlice({
  name: 'offer',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllOffersApi.pending]: (state) => {
      state.isOfferLoading = true;
    },
    [getAllOffersApi.fulfilled]: (state, action) => {
      state.offerList = action.payload;
      state.isOfferLoading = false;
    },
    [getAllOffersApi.rejected]: (state) => {
      state.isOfferLoading = false;
    },
    [getOfferByIdApi.fulfilled]: (state, action) => {
      state.selectedOffer = action.payload;
    },
    [updateOfferStatusApi.fulfilled]: (state, action) => {
      const updatedOffer = action.payload;
      const upOfferList = _.cloneDeep(state.offerList);
      const indexToUpdate = _.findIndex(upOfferList, (data) => data?._id === updatedOffer?._id);
      upOfferList[indexToUpdate] = updatedOffer;
      state.offerList = upOfferList;
    }
  }
});
export const offerActions = slice.actions;

export default slice.reducer;
